import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import App from './App';
import './styles/index.css';

// Stripe öffentlicher Schlüssel - MUSS aus Umgebungsvariablen kommen
const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

if (!stripePublicKey) {
  console.error('⚠️ REACT_APP_STRIPE_PUBLIC_KEY ist nicht gesetzt! Bitte in .env Datei konfigurieren.');
}

const stripePromise = stripePublicKey ? loadStripe(stripePublicKey) : null;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Elements stripe={stripePromise}>
        <App />
      </Elements>
    </BrowserRouter>
  </React.StrictMode>
);